import PropTypes from 'prop-types';

//PREVIEW DATA => DATA
export const PreviewDataDataProps = {
    bookmark: PropTypes.bool,
    description: PropTypes.string,
    distance: PropTypes.number,
    download: PropTypes.number,
    duration: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
    image: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string),
    miniature: PropTypes.string,
    mountain: PropTypes.bool,
    pdf: PropTypes.number,
    scenic: PropTypes.bool,
    seaside: PropTypes.bool,
    straight: PropTypes.bool,
    title: PropTypes.string,
    twisted: PropTypes.bool,
    view: PropTypes.number,
}


export const PreviewDataProps = {
    data: PropTypes.shape(PreviewDataDataProps),
    error: PropTypes.any,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
}